import React, { useState, useEffect } from 'react';
import { useScroll } from '@react-three/drei';

const sections = [
    { name: 'hello', percentage: 20 },
    { name: 'about me', percentage: 32 },
    { name: 'work', percentage: 43 },
    { name: 'education', percentage: 61 },
    { name: 'hobbies', percentage: 80 },
    { name: 'contact', percentage: 98 },
];

export function Navigation() {
    const scroll = useScroll();
    const [showTopButton, setShowTopButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPercentage = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
            setShowTopButton(scrollPercentage > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (percentage) => {
        const targetScrollTop = (percentage / 100) * (scroll.el.scrollHeight - scroll.el.clientHeight);
        scroll.el.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
    };

    const scrollToTop = () => {
        scroll.el.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div className="navigation">
                {sections.map(section => (
                    <button key={section.name} onClick={() => scrollToSection(section.percentage)}>
                        {section.name}
                    </button>
                ))}
                <button onClick={() => window.open('/Nauman Shah resume.pdf', '_blank', 'noopener,noreferrer')}>resume</button>
            </div>
            {showTopButton && (
                <button className="to-the-top" onClick={scrollToTop}>
                    to the top
                </button>
            )}
        </>
    );
}